module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/arrow-f6253ca0.svg";